import { useEffect, useRef, useState } from 'react';
import { silentMyTenancies } from '../../services/tenantPortal';
import { TENANT_ENTRY_EVENT, isTenantEntryFresh, readTenantEntry, writeTenantEntry } from '../../utils/tenantPortalEntry';

/**
 * "Kiracı paneli" menü girişi gösterilsin mi. `active` (menü/çekmece açık) olduğunda önbellek eskiyse tek bir sessiz
 * istek atılır; aksi hâlde ağ isteği yapılmaz. Davet kabulü / portal listesi önbelleği olay ile anında günceller.
 */
const useTenantPortalEntry = (userId, active) => {
  const [has, setHas] = useState(() => Boolean(readTenantEntry(userId)?.has));
  const inFlight = useRef(false);

  useEffect(() => {
    setHas(Boolean(readTenantEntry(userId)?.has));
    const onChange = () => setHas(Boolean(readTenantEntry(userId)?.has));
    window.addEventListener(TENANT_ENTRY_EVENT, onChange);
    return () => window.removeEventListener(TENANT_ENTRY_EVENT, onChange);
  }, [userId]);

  useEffect(() => {
    if (!active || !userId || inFlight.current || isTenantEntryFresh(readTenantEntry(userId))) return;
    inFlight.current = true;
    let alive = true;
    silentMyTenancies().then((res) => {
      inFlight.current = false;
      // Uç henüz yoksa / hata: önbelleğe yazma (bir sonraki açılışta yeniden denenir), menü değişmez
      if (!res?.success || !alive) return;
      const list = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.items) ? res.data.items : [];
      writeTenantEntry(userId, list.length > 0);
    });
    return () => {
      alive = false;
    };
  }, [active, userId]);

  return Boolean(userId) && has;
};

export default useTenantPortalEntry;
